<template>
    <div>
        <h2>
            {{ 'rent.title' | trans }}
        </h2>
        <ul>
            <li>
                <div class="datepicker-container">
                    <label class="gl noselect">{{ 'rent.pickDay' | trans }}</label>
                    <date-picker
                        v-model="pickday"
                        format="dd/MM/yyyy HH:mm"
                        type="datetime"
                        :lang="lang"
                        :not-before="now"
                        :time-picker-options="maxTime"
                        confirm
                    />
                </div>
                <div
                    class="gl-text getter fill"
                >
                    <label class="gl noselect">{{ 'rent.returnDay' | trans }}</label>
                    <div>{{ returnDay }}</div>
                </div>
            </li>
            <li>
                <button
                    class="btn red"
                    @click="cancel"
                >
                    {{ 'rent.cancel' | trans }}
                </button>
                <button
                    class="btn"
                    @click="selected"
                >
                    {{ 'rent.accept' | trans }}
                </button>
            </li>
        </ul>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import date from 'date-and-time';
import { isEmpty } from 'ramda';

export default {
    name: 'rent',
    props: {
        strtime: {
            type: String,
            require: true
        }
    },
    data() {
        return {
            pickday: '',
            lang: document.documentElement.lang
        };
    },
    computed: {
        time() {
            const values = this.strtime.split(':');
            let multiplier = 1;
            if (values[1] === 's') {
                multiplier = 1 / 3600;
            } else if (values[1] === 'm') {
                multiplier = 1 / 60;
            } else if (values[1] === 'd') {
                multiplier = 24;
            }
            return Number(values[0]) * multiplier;
        },
        now() {
            return Date.now();
        },
        returnDay() {
            const returnDay = this.pickday;
            let time = returnDay;

            if (returnDay === '') {
                time = new Date();
            }

            const remaining = time.getHours() - 20;
            const available = this.time + remaining;

            time = date.addHours(time, this.time - available);

            if (available > 0) {
                time = date.addHours(time, 12 + available);
            }
            const value = date.format(time, 'DD/MM/YYYY HH:mm');
            return value;
        },
        maxTime() {
            const maxtime = 20;
            let end = maxtime - 8;
            end = (end - this.time) + 8;
            if (this.time > 12) {
                end = 20;
            }
            return {
                start: '08:00',
                step: '00:30',
                end: `${end}:00`
            };
        }
    },
    methods: {
        selected () {    
            let start = this.pickday;
            if(isEmpty(start)) {
                start = new Date();
            }
            
            this.$emit('select', {
                time: this.strtime,
                return: this.returnDay,
                start: date.format(start, 'DD/MM/YYYY HH:mm')    
            });
        },
        cancel() {
            this.pickday = '';
            this.$emit('select', null);
        }
    },
    components: {
        DatePicker
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Rent.vue